function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
const SvgNumber = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  "data-animate": props.isAnimate || false,
  "data-interactive": props.animateOnInteraction || false
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: props.color || 'currentColor',
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M1 5.444 3.443 3.5h.176v8.167m2.825-6.18s1.91-2.227 3.182-.636c1.273 1.59-1.939 4.072-3.182 6.682h3.5m2.674-5.577c1.02-.34 2.382-.68 2.382 1.02 0 .976-1.008 1.28-1.61 1.363m0 0c-.448.06-.672-.001-.091-.001h.091Zm0 0c1.285.023 1.61.539 1.61 1.7 0 1.702-1.701 1.701-2.722 1.361"
}));
export default SvgNumber;